<div class="callback_body">
  <div class="callback_logo">
    <img src="assets/image/logo.svg" alt="پومودورو">
  </div>
  <div class="callback_title">لطفا چند لحظه منتظر بمانید...</div>
</div>
